import { Divider } from "primereact/divider";

import { StyledSuccessContainer } from "../../styled";
import { BouncingClock } from "./BouncingClock";

export function AwaitingProviderReview({
  publicContact,
}: {
  publicContact: any;
}) {
  return (
    <StyledSuccessContainer className="w-full flex flex-column align-items-center pt-6 px-3">
      <div className="flex relative">
        <BouncingClock />
        <p
          className="text-md gray line-height-3 message"
          style={{ minWidth: "258px" }}
        >
          Signed! Awaiting Provider Review!
        </p>
      </div>
      <p className="text-4xl font-semibold highlighted mt-1 text-center">
        Your Response is Submitted!
      </p>
      <p className="text-center line-height-3 mt-4">
        Thank you for signing. Your response has been saved and sent to your
        provider for review.
      </p>

      <Divider type="solid" className="mt-5" />
      <p className="highlighted font-medium text-xl line-height-3">
        Questions about your bill?
      </p>
      <p className="line-height-3 mt-1 text-center">
        Reach out to our support team anytime.
      </p>
      <div className="flex justify-content-center gap-4 mt-4">
        <div className="text-center gap-1 flex flex-column">
          <p className="text-sm line-height-3 font-semibold">Clear Health</p>
          <p className="text-sm line-height-3 font-normal">
            Estimate and Payment Support
          </p>
          <p className="text-sm line-height-3 font-normal">(888) 918-2522</p>
        </div>
        {publicContact().isVisible && (
          <div className="text-center flex flex-column">
            <p className="text-sm line-height-3 font-semibold">
              {publicContact().name}
            </p>
            <p className="text-sm line-height-3 gray">{publicContact().role}</p>
            <p className="text-sm line-height-3 gray">
              {publicContact().phone}
            </p>
          </div>
        )}
      </div>
    </StyledSuccessContainer>
  );
}
